<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title> DAMAGES</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <div>
          <v-row>
            <v-col cols="12">
              <v-btn color="accent" text class="float-right" to="/create-damage">
                <v-icon>mdi-plus</v-icon> Create Damage
              </v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row dense class="mt-2">
            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="6" xs="6" md="3">
              <v-btn :loading="loader" @click="getReport" color="primary">Generate Damages Report</v-btn>
            </v-col>

            <v-col cols="6">
              <!-- <v-btn text @click="generateRawMaterialsPdf" color="primary">
                <v-icon color="black" left>mdi-file-pdf-box</v-icon> Print
                Pdf Report
              </v-btn> -->
            </v-col>

            <!-- <v-col cols="6">
              <span class="style-16 float-right" style="margin-right: 30px">Total: {{ TotalValue | currency }}</span>
            </v-col> -->
          </v-row>

          <v-divider></v-divider>

          <v-row dense class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-text-field label="Search" v-model="search"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-data-table :items-per-page="2000" :mobile-breakpoint="zeroValue" :headers="headers" :items="reportData"
                :search="search">
                <template v-slot:item.Price="{ item }">
                  <span v-if="item.Price">
                    {{
                      item.Price.toLocaleString()
                    }}
                  </span>
                </template>
                <template v-slot:item.CostOfSales="{ item }">
                  <span>{{ item.BuyingPrice * item.Quantity }}</span>
                </template>
                <template v-slot:item.LineTotal="{ item }">
                  <span v-if="item.LineTotal">
                    {{
                      item.LineTotal.toLocaleString()
                    }}
                  </span>
                </template>
                <template v-slot:item.LineProfit="{ item }">
                  <span v-if="item.LineProfit">
                    {{
                      item.LineProfit.toLocaleString()
                    }}
                  </span>
                </template>

                <template v-slot:item.date="{ item }">
                  <span style="min-width: 80px; display: inline-block">
                    {{
                      item.date | date
                    }}
                  </span>
                </template>
              </v-data-table>
              <!-- snackbar -->
              <snackbar ref="snackbar"></snackbar>
            </v-col>
          </v-row>

          <v-row>
            <v-divider></v-divider>
          </v-row>

          <!-- pdf preview -->
          <pdf-preview ref="pdfPreview"></pdf-preview>
          <!-- end -->
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
export default {
  data() {
    return {
      record: {},
      TotalValue: 0,
      searchRawMaterials: null,
      rawMaterialProducts: [],
      pageItems: 500,
      IMEI: null,
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      zeroValue: 0,
      products: [],
      customers: [],
      reportData: [],
      TotalProfit: null,
      TotalQuantitySold: null,
      brands: [],
      categories: [],
      returnsData: [],
      TotalReturns: null,
      drivers: [],
      headers: [
        { text: "Product", value: "product.Name" },
        { text: "Qty", value: "quantity" },
        { text: "Unit of Measure", value: "uom.UomName" },
        { text: "Date", value: "date" }
      ],
      fields: {
        Product: "product.Name",
        Quantity: "Quantity",
        Unit: "uom.UomName",
        Date: "DocDate",
      }
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    userId() {
      return localStorage.getItem("userId");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalSales() {
      let total = 0;
      if (this.reportData.TotalSalesAmount) {
        total = this.reportData.TotalSalesAmount;
      }
      return total.toLocaleString();
    },
    role() {
      return localStorage.getItem("userRole");
    }
  },
  watch: {
    searchRawMaterials(val) {
      if (val && val !== this.select && this.queryRawMaterials(val)) {
        this.queryRawMaterials(val);
      }
    }
  },
  methods: {
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    generateRawMaterialsPdf() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select dates range", "red");
        return;
      }

      var url = "/print-raw-materials-report";
      const apiUrl = `${host}${url}`;

      const self = this;

      var data = {
        "StartDate": self.record.StartDate,
        "EndDate": self.record.EndDate,
        "ProductId": self.record.ProductId,
      }

      http.post(apiUrl, data, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        console.log(' invoice file url', fileUrl);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    queryRawMaterials(searchText) {
      const self = this;
      const url = "/search-raw-materials";
      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.rawMaterialProducts = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("get", `/products`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const data = this.record;
      const url = "/get-damages-report";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
          self.loader = false;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.IMEI = res.ResponseData.IMEI;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDrivers() {
      const self = this;
      this.$store
        .dispatch("get", `/drivers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.drivers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([
      this.getCategories(),
      this.getGenSettings(),
      // this.getBrands(),
      this.getProducts(),
      // this.getDrivers()
    ]);
  }
};
</script>

<style lang="scss" scoped></style>